import React, { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';
import { ESTADOS, ESTADO_COLORS } from './agendaConstants';
import './agendaCalendario.css';

const EstadoSelector = ({ value, onChange }) => (
  <div className="agenda-estado-botones">
    {ESTADOS.map((estado) => {
      const color = ESTADO_COLORS[estado];
      const selected = value === estado;
      return (
        <button
          key={estado}
          type="button"
          className={`agenda-estado-boton${selected ? ' agenda-estado-boton--selected' : ''}`}
          style={{
            '--estado-color': color,
            borderColor: color,
            background: selected ? color : `${color}18`,
            color: selected ? '#ffffff' : color,
          }}
          onClick={() => onChange?.(estado)}
        >
          {estado}
        </button>
      );
    })}
  </div>
);

const AgendaReunionForm = ({ open, editing, initialFecha, onCancel, onSubmit, isNarrow }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    if (editing) {
      form.setFieldsValue({
        fecha: editing.fecha,
        horaInicio: formatHoraInput(editing.horaInicio),
        horaFin: formatHoraInput(editing.horaFin),
        cliente: editing.cliente,
        contacto: editing.contacto || '',
        telefono: editing.telefono || '',
        email: editing.email || '',
        localidad: editing.localidad || '',
        producto: editing.producto || '',
        comentarios: editing.comentarios || '',
        estado: editing.estado || 'Pendiente',
      });
    } else {
      form.resetFields();
      form.setFieldsValue({
        fecha: initialFecha || undefined,
        estado: 'Pendiente',
      });
    }
  }, [open, editing, initialFecha, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await onSubmit(values);
    } catch (e) {
      if (e?.errorFields) return;
      throw e;
    }
  };

  return (
    <Modal
      title={editing ? 'Editar reunión' : 'Nueva reunión'}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      destroyOnClose
      okText="Guardar"
      width={isNarrow ? 'calc(100vw - 16px)' : 600}
      centered
      styles={{ body: { maxHeight: 'min(75vh, 560px)', overflowY: 'auto' } }}
    >
      <Form form={form} layout="vertical" requiredMark={false} style={{ marginTop: 8 }}>
        <Form.Item name="fecha" label="Fecha" rules={[{ required: true, message: 'Requerido' }]}>
          <Input type="date" />
        </Form.Item>
        <div style={{ display: 'flex', gap: 12 }}>
          <Form.Item name="horaInicio" label="Hora inicio" style={{ flex: 1 }}>
            <Input type="time" />
          </Form.Item>
          <Form.Item name="horaFin" label="Hora fin" style={{ flex: 1 }}>
            <Input type="time" />
          </Form.Item>
        </div>
        <Form.Item name="cliente" label="Cliente" rules={[{ required: true, message: 'Requerido' }]}>
          <Input placeholder="Nombre del cliente" />
        </Form.Item>
        <Form.Item name="contacto" label="Contacto">
          <Input placeholder="Persona de contacto" />
        </Form.Item>
        <div style={{ display: 'flex', gap: 12 }}>
          <Form.Item name="telefono" label="Teléfono" style={{ flex: 1 }}>
            <Input placeholder="Teléfono" />
          </Form.Item>
          <Form.Item name="email" label="Email" style={{ flex: 1 }}>
            <Input type="email" placeholder="correo@ejemplo.com" />
          </Form.Item>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <Form.Item name="localidad" label="Localidad" style={{ flex: 1 }}>
            <Input placeholder="Ciudad / localidad" />
          </Form.Item>
          <Form.Item name="producto" label="Producto" style={{ flex: 1 }}>
            <Input placeholder="Producto" />
          </Form.Item>
        </div>
        <Form.Item name="comentarios" label="Comentarios">
          <Input.TextArea rows={3} placeholder="Notas, seguimiento, etc." />
        </Form.Item>
        <Form.Item name="estado" label="Estado" initialValue="Pendiente">
          <EstadoSelector />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const formatHoraInput = (hora) => {
  if (!hora) return undefined;
  return String(hora).slice(0, 5);
};

export default AgendaReunionForm;
